DYC.factory('loginModal', function (dialog) {
    /* jshint camelcase:false */
    // JUST FOR TEST
    // DYCONFIG.sso.loginDialog = 'http://192.168.31.198:8080/sso/login-dialog.html';
    var ssoLoginUrl = DYCONFIG.sso.loginDialog + '?url=' + encodeURIComponent(rcpAid.getNoTokenUrl()) + '&hideReg=1';
    var str = '';
    var pathnameList = DYCONFIG.noLoginPage || [];
    var pathname = location.pathname;

    function initLoginStr(urlTmp) {
        return [
            '<style>',
            '#login-window input{background-repeat:no-repeat;background-position:4px center;padding:7px 5px 3px 30px;border:1px solid #ccc;outline:none;margin:5px 0 20px;width:250px;display:block;}',
            '#login-window input:focus{border:1px solid #1093be;}',
            '#login-window button{display:block;width:100%;padding:0;line-height:30px;}',
            '#login-window .loading-circle::before{left:-3px;top:-3px;border: 3px solid rgba(0,0,0,.2);}',
            '#login-window .loading-circle::after{left:-3px;top:-3px;border:3px solid transparent;border-bottom-color:rgba(255,255,255,.9);}',
            '#login-window .inner{padding:0}',
            '#login-window .close-ic{right:99px}',
            'button.btn-default{color:#fff;background-color:#02c4bd;border-color:#02c4bd;}',
            'button.btn{display:inline-block;padding:6px 6px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;border:1px solid transparent;border-radius:4px;}',
            '.login-dialog{height:560px;border:none;position: relative;}',
            '</style>',
            '<div class="win-login-style s-p-win" id="login-window" style="width: 550px">',
            '<div class="win-bd"></div>',
            '<div class="my-wrap jf-drag">',
            '<div class="my-main">',
            '<div class="win-hd">',
            '<i class="iconfont i-close color-cyan f-r close-ic close" ></i>',
            '</div>',
            '<div class="inner">',
            '<iframe src="' + urlTmp + '" width="0" class="login-dialog" allowTransparency="true" style="background:none transparent;" onload="this.width=540"></iframe>',
            '</div>',
            '</div>',
            '</div>',
            '</div>'
        ].join('');
    }

    return {
        show: function (args) {
            var urlTmp = ssoLoginUrl;
            if (args) {
                var otherArg = '';
                angular.forEach(args, function (val, key) {
                    if (!val) {
                        console.log('args has no value');
                        return;
                    }
                    otherArg += '&' + key + '=' + val;
                });
                console.log('this is login-modal received other args: ', otherArg);
                urlTmp += otherArg;
            }
            str = initLoginStr(urlTmp);
            var oLoginWin = $('#login-window');
            if (oLoginWin.length === 0) {
                $(document.body).append(str);
                // 判断当前是否在无需登录的白名单里（不在关闭登录窗调回首页）
                console.log('this is judge result', $.inArray(pathname, pathnameList));
                if ($.inArray(pathname, pathnameList) === -1) {
                    $('.iconfont.i-close.color-cyan').unbind('click').bind('click', function () {
                        console.log('this is close window return index html');
                        location.href = location.protocol + '//' + location.host + '/';
                        $('.jf-mask').remove();
                        $('#login-window').remove();
                    });
                } else {
                    $('.iconfont.i-close.color-cyan').unbind('click').bind('click', function () {
                        console.log('this is close window');
                        $('.jf-mask').remove();
                        $('#login-window').remove();
                    });
                }
            }
            var submitLock;
            $('#login-window').window({mask: true});
        }
    };
});

DYC.run(function (service, loginModal) {
    service.expand('loginModal', function () {
        return loginModal;
    });
});


// WEBPACK FOOTER //
// ./src/common/service/login-modal.js